"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformDateToDDMMYYYYString = void 0;
function transformDateToDDMMYYYYString(date) {
    const doubles = ["01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12"];
    const dateToString = new Date(date);
    const year = dateToString.getUTCFullYear().toString();
    const month = doubles[dateToString.getUTCMonth()];
    let day = dateToString.getUTCDate().toString();
    if (day.length === 1) {
        day = `0${day}`;
    }
    return `${day}.${month}.${year}`;
}
exports.transformDateToDDMMYYYYString = transformDateToDDMMYYYYString;
//# sourceMappingURL=transformDateToDDMMYYYYString.js.map